export enum WholesalerIntegrationStepsEnum {
  SelectType = 0,
  PendingConnection = 1,
  Finish = 2,
}
